// import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import Calender from "../../../Assest/Images/Calender.jpg";
// import { fetchData } from "../../../BaseUrl";

// function Calander() {
//   const [calander, setCalander] = useState([]);
//   const isMobile = useMediaQuery("(max-width:600px)");

//   const styles = {
//     container: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       minHeight: "90vh",
//       padding: isMobile ? "1rem" : "2rem 6rem",
//       marginTop: "1rem",
//       backgroundColor: "#F7F3FC",
//       flexDirection: isMobile ? "column" : "row",
//     },
//     textContainer: {
//       textAlign: "center",
//       marginBottom: isMobile ? "1rem" : "0",
//     },
//     annual: {
//       fontSize: isMobile ? "28px" : "64px",
//       fontWeight: "bold",
//       color: "#007bff",
//       marginBottom: "10px",
//     },
//     calendar: {
//       fontSize: isMobile ? "36px" : "85px",
//       color: "#000",
//       lineHeight: "1.5",
//       fontWeight: "bold",
//     },
//     date: {
//       fontSize: isMobile ? "24px" : "50px",
//       color: "#000",
//       lineHeight: "1.5",
//       fontWeight: "bold",
//     },
//     imageContainer: {
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//     },
//     image: {
//       width: "100%",
//       maxWidth: isMobile ? "300px" : "500px",
//     },
//     tableContainer: {
//       maxWidth: "85%",
//       overflowX: "auto",
//       margin: "auto",
//       marginTop: "2rem",
//       marginBottom: "4rem",
//       // borderRadius: "10px",
//       boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
//     },
//     tableHeader: {
//       backgroundColor: "#1976D2",
//     },
//     tableHeaderText: {
//       color: "black",
//       fontWeight: "bold",
//       textAlign: "center",
//       fontSize: isMobile ? "20px" : "30px",
//       padding: "12px",
//     },
//     tableCellMonth: {
//       textAlign: "center",
//       fontSize: isMobile ? "16px" : "20px",
//       fontWeight: "bold",
//       padding: "8px",
//       backgroundColor: "#87CEFA",
//       color: "black",
//       border: "2px solid white",
//     },
//     tableCell: {
//       textAlign: "center",
//       fontSize: isMobile ? "14px" : "18px",
//       padding: "8px",
//       backgroundColor: "#87CEFA",
//       fontWeight: "bold",
//       border: "2px solid white",
//     },
//   };

//   useEffect(() => {
//     getCalander();
//   }, []);

//   const getCalander = async () => {
//     try {
//       const response = await fetchData("/admin/calendar/retrieve");
//       setCalander(response?.data?.length ? response.data : []);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setCalander([]);
//     }
//   };

//   const groupedData = [];
//   let monthMap = new Map();
//   let addedMonths = new Set();

//   calander.forEach((row) => {
//     if (monthMap.has(row.month)) {
//       monthMap.set(row.month, monthMap.get(row.month) + 1);
//     } else {
//       monthMap.set(row.month, 1);
//     }
//   });

//   calander.forEach((row) => {
//     let showMonth = !addedMonths.has(row.month);
//     addedMonths.add(row.month);

//     groupedData.push({
//       ...row,
//       rowSpan: showMonth ? monthMap.get(row.month) : 0,
//     });
//   });

//   return (
//     <div style={{ paddingTop: isMobile ? "3rem" : "6rem", minHeight: "100vh" }}>
//       <Box sx={styles.container}>
//         <Grid container spacing={4} alignItems="center">
//           <Grid item xs={12} md={6} sx={styles.imageContainer}>
//             <img src={Calender} alt="Calendar" style={styles.image} />
//           </Grid>
//           <Grid item xs={12} md={6} sx={styles.textContainer}>
//             <Typography sx={styles.annual}>Annual</Typography>
//             <Typography sx={styles.calendar}>Calendar</Typography>
//             <Typography sx={styles.date}>2025-2026</Typography>
//           </Grid>
//         </Grid>
//       </Box>

//       <TableContainer component={Paper} sx={styles.tableContainer}>
//         <Table>
//           <TableHead>
//             <TableRow sx={styles.tableHeader}>
//               <TableCell colSpan={3} sx={styles.tableHeaderText}>
//                 Highlights and Holidays
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {groupedData.length > 0 ? (
//               groupedData.map((row, index) => (
//                 <TableRow key={index}>
//                   {/* {row.rowSpan > 0 && (
//                     <TableCell sx={styles.tableCellMonth} rowSpan={row.rowSpan}>
//                       {row.month}
//                     </TableCell>
//                   )} */}
//                   <TableCell sx={styles.tableCell}>{row.date}</TableCell>
//                   <TableCell sx={styles.tableCell}>{row.description}</TableCell>
//                 </TableRow>
//               ))
//             ) : (
//               <TableRow>
//                 <TableCell colSpan={3} sx={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}>
//                   No data available
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </div>
//   );
// }

// export default Calander;

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Paper,
  Grid,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import Calender from "../../../Assest/Images/Calender.jpg"; // Make sure this path is correct
import colors from "../../../Assest/Theme/Color";

const data = [
  {
    month: "July",
    entries: [
      { date: "1", event: "Official Start" },
      { date: "11", event: "Admins Meet" },
      { date: "18", event: "Teachers Meet" },
      { date: "19", event: "Admins Meet" },
      { date: "26", event: "Evaluation" },
    ],
  },
  {
    month: "August",
    entries: [
      { date: "8", event: "Open House/First Day of School" },
      { date: "15", event: "Lesson-1" },
      { date: "22", event: "Lesson-2" },
      { date: "29", event: "Lesson-3/Online Week" },
    ],
  },
  {
    month: "September",
    entries: [
      { date: "5", event: "Lesson-4" },
      { date: "12", event: "Lesson-5" },
      { date: "19", event: "Lesson-6/Online Week" },
      { date: "26", event: "Student Holiday" },
    ],
  },
  {
    month: "October",
    entries: [
      { date: "3", event: "Revision Day" },
      { date: "10", event: "Team 1 Exam /End of Quater" },
      { date: "17", event: "Lesson-7/TES Project Starts" },
      { date: "24", event: "Lesson-8 /Lockdown Drill" },
      { date: "31", event: "Lesson-9" },
    ],
  },
  {
    month: "November",
    entries: [
      { date: "7", event: "Lesson-10/Culturals" },
      { date: "8", event: "Event" },
      { date: "14", event: "Lesson-11" },
      { date: "21", event: "Lesson-12/Online Week" },
      { date: "26", event: "Student Holiday" },
    ],
  },
  {
    month: "December",
    entries: [
      { date: "5", event: "Revision" },
      { date: "12", event: "Team 2 Exam/End of Quarter" },
      { date: "19", event: "Lesson-13" },
      { date: "26", event: "Student Holiday" },
    ],
  },
  {
    month: "January",
    entries: [
      { date: "2", event: "Student Holiday" },
      { date: "9", event: "Lesson-14" },
      { date: "16", event: "Lesson-15" },
      { date: "23", event: "Lesson-16" },
      { date: "30", event: "Lesson-17/Weather Drill" },
    ],
  },
  {
    month: "February",
    entries: [
      { date: "6", event: "Lesson-18" },
      { date: "13", event: "Lesson-19/Online Week" },
      { date: "20", event: "Lesson-20/Revision" },
      { date: "27", event: "Term 3 Exam /End of Quarter" },
    ],
  },
  {
    month: "March",
    entries: [
      { date: "6", event: "Teacher Handoff Day" },
      { date: "7", event: "Graduation Day" },
      { date: "27", event: "Official/Admin Closing Day" },
    ],
  },
  { month: "April", entries: [{ date: "0", event: "No Class" }] },
  { month: "May", entries: [{ date: "0", event: "No Class" }] },
  { month: "June", entries: [{ date: "0", event: "No Class" }] },
];

const CalendarTable = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const styles = {
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: "100%",
      maxWidth: isMobile ? "300px" : "500px",
    },
    annual: {
      fontSize: isMobile ? "20px" : "30px",
      fontWeight: 600,
      color: colors.primary,
      textAlign: "center",
    },
    calendar: {
      fontSize: isMobile ? "36px" : "85px",
      color: "#000",
      lineHeight: "1.2",
      fontWeight: "bold",
      textAlign: "center",
    },
    date: {
      fontSize: isMobile ? "20px" : "32px",
      fontWeight: 500,
      color: "#444",
      textAlign: "center",
    },
  };

  const cellStyle = {
    bgcolor: "#a6d66e",
    border: "1px solid #fff",
    fontSize: "20px",
    fontWeight: "400",
    textAlign: "center",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "6px",
    paddingRight: "6px",
    lineHeight: "1",
  };

  return (
    <div style={{ paddingTop: isMobile ? "3rem" : "6rem", minHeight: "100vh" }}>
      <Box sx={{ px: 2 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} sx={styles.imageContainer}>
            <img src={Calender} alt="Calendar" style={styles.image} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography sx={styles.annual}>Annual</Typography>
            <Typography sx={styles.calendar}>Calendar</Typography>
            <Typography sx={styles.date}>2025–2026</Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ p: 3, width: "80%", margin: "auto" }}>
        <div style={{ display: "flex", justifyContent: "end" }}>
          {/* <Button
          // size="small"
          disabled
          sx={{
            textTransform: "none",
            marginTop: 2,
            background: "linear-gradient(90deg, #59B7FF 0%, #336599 100%)",
            color: "#FFFF!important",
            px: 1.9,
            // opacity: 0.5,
            borderRadius:'8px',
            cursor: "not-allowed",
            marginBottom:2
          }}
        >
          Calendar View
        </Button> */}
        </div>
        <p style={{ fontSize: "20px", fontWeight: "bold" }}>
          Event dates are subject to change based on facility availability.
        </p>
        <p style={{ fontSize: "20px", fontWeight: "bold" }}>
          Some classes listed below may be conducted online based on facility
          availability.
        </p>
        <Typography
          variant="h4"
          align="center"
          sx={{
            bgcolor: "#2b5a85",
            color: "#fff",
            py: 1,
            borderRadius: "4px 4px 0 0",
            marginBottom: "0.4%",
          }}
        >
          Highlights and Holidays
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {data.map((monthData) => (
                <React.Fragment key={monthData.month}>
                  {monthData.entries.map((row, index) => (
                    <TableRow key={monthData.month + row.date}>
                      {index === 0 && (
                        <TableCell
                          rowSpan={monthData.entries.length}
                          sx={{
                            bgcolor: "#97c25b",
                            color: "#000",
                            fontWeight: "800",
                            textAlign: "center",
                            verticalAlign: "middle",
                            border: "1px solid #fff",
                            minWidth: 100,
                            fontSize: "25px",
                          }}
                        >
                          {monthData.month}
                        </TableCell>
                      )}
                      <TableCell
                        // sx={{
                        //   bgcolor: "#a6d66e",
                        //   textAlign: "center",
                        //   border: "1px solid #000",
                        //   fontSize: "25px",
                        //   fontWeight: "500",
                        // }}
                        sx={cellStyle}
                      >
                        {row.date}
                      </TableCell>
                      <TableCell
                        // sx={{
                        //   bgcolor: "#a6d66e",
                        //   border: "1px solid #000",
                        //   fontSize: "25px",
                        //   fontWeight: "500",
                        //   textAlign: "center",
                        // }}
                        sx={cellStyle}
                      >
                        {row.event}
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

export default CalendarTable;
